import React from 'react';

import LocationIcon from 'assets/icons/Location.svg';

import Reveal from '../../blocks/Reveal';

export interface ILocation {
  name: string;
  address: string;
}

export interface ILocations {
  title: string;
  locations: ILocation[];
  note: string;
}

const Locations = ({ title, locations, note }: ILocations) => {
  const createLocations = () =>
    locations.map(location => (
      <div
        key={`${location.name}: ${location.address}`}
        className='flex items-center mb-8'
      >
        <Reveal>
          <LocationIcon className='w-9 mr-5' />
          <div className='flex-1'>
            <h3 className='uppercase font-light'>{location.name}</h3>
            <p className='font-light mt-1'>{location.address}</p>
          </div>
        </Reveal>
      </div>
    ));

  return (
    <div>
      <Reveal>
        <h3 className='uppercase mb-9'>{title}</h3>
      </Reveal>

      {createLocations()}
      <Reveal>
        <h3 className='font-light'>{note}</h3>
      </Reveal>
    </div>
  );
};

export default Locations;
